var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_offer",
    clipPath: "url(#clip0_585_80423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0142 8.68061L9.01422 2.68061C8.77422 2.44061 8.44089 2.29395 8.07422 2.29395H3.40755C2.67422 2.29395 2.07422 2.89395 2.07422 3.62728V8.29394C2.07422 8.66061 2.22089 8.99395 2.46755 9.24061L8.46755 15.2406C8.70755 15.4806 9.04088 15.6273 9.40755 15.6273C9.77422 15.6273 10.1076 15.4806 10.3476 15.2339L15.0142 10.5673C15.2609 10.3273 15.4076 9.99394 15.4076 9.62728C15.4076 9.26061 15.2542 8.92061 15.0142 8.68061ZM4.40755 5.62728C3.85422 5.62728 3.40755 5.18061 3.40755 4.62728C3.40755 4.07395 3.85422 3.62728 4.40755 3.62728C4.96089 3.62728 5.40755 4.07395 5.40755 4.62728C5.40755 5.18061 4.96089 5.62728 4.40755 5.62728Z",
    fill: "#389E0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_80423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.740234 0.960449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0da4bf04cce8170dd66736adb7161afe.svg";
export { ForwardRef as ReactComponent };